(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./toast.less", "../popup", "../image"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./toast.less"), require("../popup"), require("../image"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.toast, global.popup, global.image);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _toast, _popup, _image) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _popup = _interopRequireDefault(_popup);
  _image = _interopRequireDefault(_image);

  var _components;

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "fos-toast"
      }, [_c('nx-popup', {
        attrs: {
          "value": _vm.visible,
          "hasMask": _vm.hasMask,
          "maskClosable": false,
          "lockScroll": false,
          "ariaAutoFocus": _vm.ariaAutoFocus,
          "position": _vm.position
        },
        on: {
          "show": _vm.$_onShow,
          "hide": _vm.$_onHide
        }
      }, [_vm.$slots.default ? _c('div', {
        staticClass: "fos-toast-content",
        style: {
          'margin-top': _vm.marginTop
        }
      }, [_vm._t("default")], 2) : _c('div', {
        staticClass: "fos-toast-content",
        class: {
          'fos-toast-content-icon': _vm.img
        },
        style: {
          'margin-top': _vm.marginTop
        }
      }, [_vm.toastContent && _vm.lineClamp && !_vm.img ? _c('div', {
        staticClass: "fos-toast-text line-clamp"
      }, [_c('span', [_vm._v(_vm._s(_vm.toastContent))])]) : _vm.toastContent && !_vm.img ? _c('div', {
        staticClass: "fos-toast-text",
        domProps: {
          "innerHTML": _vm._s(_vm.toastContent)
        }
      }) : _c('div', {
        staticClass: "fos-toast-small"
      }, [_c('nx-image', {
        staticClass: "fos-toast-img",
        attrs: {
          "src": _vm.img
        }
      }), _vm.lineClamp ? _c('div', {
        staticClass: "fos-toast-small-content line-clamp"
      }, [_c('span', [_vm._v(_vm._s(_vm.toastContent))])]) : _c('div', {
        staticClass: "fos-toast-small-content",
        domProps: {
          "innerHTML": _vm._s(_vm.toastContent)
        }
      })], 1)])])], 1);
    },
    name: 'fos-toast',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _popup.default.name, _popup.default), (0, _defineProperty2.default)(_components, _image.default.name, _image.default), _components),
    props: {
      img: {
        type: String,
        default: ''
      },
      // desc: {
      //   type: String,
      //   default: '',
      // },
      content: {
        type: String,
        default: ''
      },
      // 抛弃原来的content属性，使用tips属性
      tips: {
        type: String,
        default: ''
      },
      duration: {
        type: Number,
        default: 2000
      },
      hasMask: {
        type: Boolean,
        default: false
      },
      marginTop: {
        type: String,
        default: ''
      },
      ariaAutoFocus: {
        type: Boolean,
        default: true
      },
      position: {
        type: String,
        default: 'bottom'
      },
      lineClamp: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      return {
        visible: false
      };
    },
    computed: {
      toastContent: function toastContent() {
        return this.content || this.tips;
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.$_timer) {
        clearTimeout(this.$_timer);
      }
    },
    methods: {
      $_onShow: function $_onShow() {
        this.$emit('show');
      },
      $_onHide: function $_onHide() {
        this.$emit('hide');
      },
      fire: function fire() {
        var _this = this;

        if (this.$_timer) {
          clearTimeout(this.$_timer);
        }

        if (this.visible && this.duration) {
          this.$_timer = setTimeout(function () {
            _this.hide();
          }, this.duration);
        }
      },
      show: function show() {
        this.visible = true;
        this.fire();
      },
      hide: function hide() {
        this.visible = false;
      }
    }
  };
  _exports.default = _default;
});